
const apiConstents = {

    dateTimeFormat:'DD/MM/YYYY HH:mm:ss',
    dateTimeFormat1:'DD/MM/YYYY',
    dateTimeFormat2:"MMMM, DD",
    dateTimeFormat3:'DD MM YYYY',
    editRoleManager:'Content_Manager',
    editRoleExpert : 'Content_Expert',
    allDataLimit: 'pagination[limit]=-1',
    populateAll: 'populate=*',

    PackagePopulate:'populate=crop_connect,package_time_lines,package_time_lines.package_practices,package_time_lines.package_practices.package_time_line,package_time_lines.practice_relations,package_time_lines.practice_weather_mappings,package_time_lines.practice_weather_mappings.prevailing_weather,package_time_lines.practice_weather_mappings.package_time_line,package_time_lines.practice_weather_mappings.package_practice,package_time_lines.package_practices.practice_category' //
} 

export default apiConstents;